import { render, staticRenderFns } from "./HomeBackground.vue?vue&type=template&id=2487295e&scoped=true&"
import script from "./HomeBackground.vue?vue&type=script&lang=js&"
export * from "./HomeBackground.vue?vue&type=script&lang=js&"
import style0 from "./HomeBackground.vue?vue&type=style&index=0&id=2487295e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2487295e",
  null
  
)

export default component.exports